import { Dropzone } from 'components'

const RoomFileInput = ({ thumbnailUrl, onFileChange }) => (
  <Dropzone existingImageUrl={thumbnailUrl} onChange={onFileChange} />
)

export default RoomFileInput
